import { appIntl } from 'utility/context/IntlGlobalProvider';
import { HelpCircle, X, Check, AlertTriangle, Info, Bell } from 'react-feather';
import { Badge } from 'reactstrap';
import Icon from 'utility/icomoon';
import moment from 'moment';

export const getFilteredEntityTypesOptions = (entityTypesOptions, userAccessLevelId) => {
  return entityTypesOptions
    .filter((entityType) => (userAccessLevelId === 13 ? entityType.id !== 0 : entityType))
    .filter((entityType) =>
      userAccessLevelId === 11 || userAccessLevelId === 7
        ? entityType.id !== 0 && entityType.id !== 18 && entityType.id !== 43
        : entityType
    )
    .filter((entityType) =>
      userAccessLevelId === 4
        ? entityType.id !== 0 &&
          entityType.id !== 18 &&
          entityType.id !== 30 &&
          entityType.id !== 43
        : entityType
    );
};

export const getMessageTypesStyles = (
  messageType: number
): { text: string; color: string; icon: string } => {
  const intl = appIntl();

  switch (messageType) {
    case 1:
      return {
        text: intl.formatMessage({ id: `notifications.messageType${messageType}` }),
        color: 'success',
        icon: 'Check'
      };

    case 2:
      return {
        text: intl.formatMessage({ id: `notifications.messageType${messageType}` }),
        color: 'danger',
        icon: 'X'
      };
    case 3:
      return {
        text: intl.formatMessage({ id: `notifications.messageType${messageType}` }),
        color: 'warning',
        icon: 'AlertTriangle'
      };
    case 4:
      return {
        text: intl.formatMessage({ id: `notifications.messageType${messageType}` }),
        color: 'info',
        icon: 'Info'
      };

    case 5:
      return {
        text: intl.formatMessage({ id: `notifications.messageType${messageType}` }),
        color: 'primary',
        icon: 'HelpCircle'
      };

    default:
      return {
        text: intl.formatMessage({ id: `notifications.notification` }),
        color: 'primary',
        icon: 'Bell'
      };
  }
};

export const getMessageTypePill = (messageType: number) => {
  const styles = getMessageTypesStyles(messageType);

  if (messageType === null) {
    return null;
  }

  const { text, color, icon } = styles;

  return (
    <Badge pill color={`light-${color}`} style={{ fontSize: '12px' }}>
      <Icon icon={icon} className={'mr-25'} size={14} color={color} />
      {text}
    </Badge>
  );
};

export const getMessageStatusPill = (status: any) => {
  const intl = appIntl();

  if (status === null) {
    return null;
  }

  if (status === 0) {
    return (
      <Badge pill color="light-danger" style={{ fontSize: '12px' }}>
        {intl.formatMessage({ id: `notifications.status.1` })}
      </Badge>
    );
  } else if (status === 1) {
    return (
      <Badge pill color="light-success" style={{ fontSize: '12px' }}>
        {intl.formatMessage({ id: `notifications.status.2` })}
      </Badge>
    );
  }
};

export const getMessageTypeAvatarProps = (messageType) => {
  switch (messageType) {
    case 1:
      return {
        color: 'light-success',
        icon: <Check size={20} />
      };
    case 2:
      return {
        color: 'light-danger',
        icon: <X size={20} />
      };
    case 3:
      return {
        color: 'light-warning',
        icon: <AlertTriangle size={20} />
      };
    case 4:
      return {
        color: 'light-info',
        icon: <Info size={20} />
      };
    case 5:
      return {
        color: 'light-primary',
        icon: <HelpCircle size={20} />
      };
    default:
      return {
        color: 'light-primary',
        icon: <Bell size={20} />
      };
  }
};
